import { motion } from "framer-motion";
import { WHATSAPP } from "../lib/brand";

// Simple WhatsApp icon svg
const WA = (props) => (
  <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" {...props}>
    <path d="M16 3C9 3 3.4 8.6 3.4 15.6c0 2.5.7 4.9 2 7L3 29l6.6-2.3c2 1.1 4.2 1.7 6.4 1.7 7 0 12.6-5.6 12.6-12.6C28.6 8.6 23 3 16 3zm0 22.9c-2 0-3.9-.5-5.6-1.6l-.4-.2-3.9 1.3 1.3-3.8-.3-.4c-1.2-1.9-1.8-4-1.8-6.2 0-5.9 4.8-10.6 10.7-10.6s10.6 4.8 10.6 10.7c0 5.8-4.8 10.8-10.6 10.8zm5.9-7.9c-.3-.2-1.9-1-2.2-1.1-.3-.1-.5-.2-.8.2-.2.3-.9 1.1-1.1 1.4-.2.2-.4.3-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.8-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.6.1-.1.3-.4.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.1-.7-1.9-1-2.5-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.3 1.4 3.5c.2.3 2.4 3.6 5.7 5 3.4 1.4 3.4.9 4 .9.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.2-.3-.3-.6-.4z" />
  </svg>
);

export default function FloatingWhatsApp() {
  return (
    <motion.a
      href={WHATSAPP}
      target="_blank"
      rel="noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="fab-wa pulse-emerald"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <WA />
    </motion.a>
  );
}
